import React, { type FC } from "react";

import { SkeletonBox } from "~/components/skeleton/box";
import { HealthStateValue } from "~/models/dto";

import { healthStateToColorForText, stateToText } from "../../common/functions";
import type { Api } from "../../common/openapi";

import { healthStateToBackgroundColor } from "./health-state-background-color";

export interface HealthStateBadgeProps {
	/**
	 * when `null` the badge turns into a skeleton
	 */
	state?: Api.HealthStateValue | HealthStateValue | undefined | null;
}

export const HealthStateBadge: FC<HealthStateBadgeProps> = ({ state = HealthStateValue.Uninitialized, ...props }) => {
	if (state === null) {
		return <SkeletonBox {...props} className="h-[19px] w-14 rounded-[20px]" />;
	}

	const stateText = stateToText(state);

	return (
		<div
			data-testid="state-label"
			{...props}
			className="flex h-[19px] items-center justify-center rounded-[20px] border border-current leading-[19px]"
			style={{
				color: healthStateToColorForText(state),
				backgroundColor: healthStateToBackgroundColor(state),
			}}
		>
			<span className="mx-3 my-[3px] text-10 uppercase tracking-[0.3px]">{stateText}</span>
		</div>
	);
};
